import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    GET_SUMMARY_REPORT_DETAILS: createActionType(FULL_NAMESPACE, "GET_SUMMARY_REPORT_DETAILS"),
    GET_SUMMARY_REPORT_DETAILS_COMPLETED: createActionType(FULL_NAMESPACE, "GET_SUMMARY_REPORT_DETAILS_COMPLETED"),
    GET_SUMMARY_REPORT_DETAILS_REJECTED: createActionType(FULL_NAMESPACE, "GET_SUMMARY_REPORT_DETAILS_REJECTED"),
    CLEAR_DATA: createActionType(FULL_NAMESPACE, "CLEAR_DATA"),
    SET_SUMMARY_REPORT_DATA: createActionType(FULL_NAMESPACE, "SET_SUMMARY_REPORT_DATA"),
    SAVE_SUMMARY_REPORT_DETAILS: createActionType(FULL_NAMESPACE, "SAVE_SUMMARY_REPORT_DETAILS"),
    SAVE_SUMMARY_REPORT_DETAILS_COMPLETED: createActionType(FULL_NAMESPACE, "SAVE_SUMMARY_REPORT_DETAILS_COMPLETED"),
    SAVE_SUMMARY_REPORT_DETAILS_REJECTED: createActionType(FULL_NAMESPACE, "SAVE_SUMMARY_REPORT_DETAILS_REJECTED")
};
